import React from 'react';

const ReligionFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.2 17.1999V10.8999L14.5 8.6499M18.55 17.1999H1.45001M2.80001 17.1999V10.8999L5.05001 9.0999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.20001 17.1999V12.6999C8.20001 11.7058 9.0059 10.8999 10 10.8999V10.8999V10.8999C10.9941 10.8999 11.8 11.7058 11.8 12.6999V17.1999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.5 17.2V5.95M14.5 5.5V17.2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.35132 7.45114L9.30261 2.34992C9.76221 1.95596 10.4404 1.95596 10.9 2.34992L16.8513 7.45114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReligionFilterIcon;
